import PC from './pc';
import H5 from './h5';
import React from 'react';

interface Props {
  children?: React.ReactNode;
}

const SwitchChannel: React.FC<Props> = ({ children }) => {
  return isMobile ? <H5>{children}</H5> : <PC />;
};
export default SwitchChannel;
